/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * FinPath API
 * Backend API programu FinPath (panel admina + aplikacja mobilna).
 * OpenAPI spec version: 0.1.0
 */

/**
 * * `none` - none
 * * `automatic` - automatic
 * * `manual` - manual
 */
export type ReceiptConfirmationModeEnum = typeof ReceiptConfirmationModeEnum[keyof typeof ReceiptConfirmationModeEnum];


export const ReceiptConfirmationModeEnum = {
  none: 'none',
  automatic: 'automatic',
  manual: 'manual',
} as const;
